import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { logbaseService } from "../../services/logbase.service";
//import { NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { dataService } from "../../services/data.service";

@Component({
  selector: 'app-part-details',
  templateUrl: './part-details.component.html',
  styleUrls: ['./part-details.component.scss']
})
export class PartDetailsComponent implements OnInit {
  localPkgStatus: string;
  packageOverallStatus: any;
  routePackageID: any;
  partLSData: any;

  partInfo: any = null;
  globalInfo: any = null;
  packageInfo: any = null;
  supplierInfo: any = null;
  supplyInfo: any = null;
  istabActive: any[];

  @Input() partInfoData: string;

  @ViewChild('content') content;
  id: any;
  private sub: any;
  packageID: any;
  //partData: any;  

  constructor(
    private logBaseService: logbaseService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private dataService: dataService,
    private router: Router
  ) {

  }

  ngOnInit() {
    this.istabActive = ['', '', '']
    let activeUrls = this.router.url
    if (activeUrls.includes("partsInfo")) {
      this.istabActive[0] = 'active'
    }
    if (activeUrls.includes("supplyInfo")) {
      this.istabActive[1] = 'active'
    }
    if (activeUrls.includes("packageInfo")) {
      this.istabActive[2] = 'active'
    }

    //dataService.packageID$.subscribe(data => this.packageID = data);
    this.packageID = localStorage.getItem('packageID');

    setTimeout(() => {
      this.packageID = localStorage.getItem('packageID');
      this.localPkgStatus = localStorage.getItem('packageOverallStatus');
      if (this.localPkgStatus == 'new') {
        this.packageOverallStatus = 'New';
      } else if (this.localPkgStatus == 'inProgress') {
        this.packageOverallStatus = 'In Progress';
      } else if (this.localPkgStatus == 'underReview') {
        this.packageOverallStatus = 'Under Review';
      } else if (this.localPkgStatus == 'approved') {
        this.packageOverallStatus = 'Approved';
      } else if (this.localPkgStatus == 'rejected') {
        this.packageOverallStatus = 'Rejected';
      }
    }, 1000);

  }

  onTabClick(index) {
    this.istabActive = ['', '', '']
    let activeUrls = this.router.url
    if (activeUrls.includes("partsInfo")) {
      this.istabActive[index] = 'active'
    }
    if (activeUrls.includes("supplyInfo")) {
      this.istabActive[index] = 'active'
    }
    if (activeUrls.includes("packageInfo")) {
      this.istabActive[index] = 'active'

    }
  }
}
